import { apiLocal } from './servers/apiInternal';

export interface PushAtrasadosRow {
  pushId: string;
  cnj: string;
  createdAt: string | null;
  atraso: number;
  demandid?: string | null;
  logado?: boolean;
}

export interface PushAtrasadosResponse {
  success: boolean;
  page: number;
  pageSize: number;
  total: number;
  fromCache: boolean;
  cacheExpiresIn: number | null;
  data: PushAtrasadosRow[];
}

const pushAtrasados = {
  list: async (page = 1, forceRefresh = false, filters?: Record<string, any>): Promise<PushAtrasadosResponse> => {
    const params: Record<string, any> = { page };
    if (forceRefresh) params.forceRefresh = "true";
    if (filters) {
      // copia os filtros para os params (ex: pushId, demandid, cnj, logado)
      Object.assign(params, filters);
    }
    const res = await apiLocal.get(`/push/atrasados`, { params });
    return res.data;
  },
};

export default pushAtrasados;
